<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-搜索结果">
    <img src="http://123.56.170.62:9999/static/bg/banner3.png" alt />
    <div class="content">
      <AllHeader title="搜索结果"></AllHeader>
      <div class="tswrapper" v-if="newsData.length > 0">
        <div class="tscontent">
          <div class="tsbox" v-for="item in newsData" :key="item.name">
            <h3 @click="$router.push(`/newsContent/${item.id}`)">
              {{ item.name }}
            </h3>
            <div class="tstime">
              <p>时间 : {{ item.putime }}</p>
              <p>浏览量 : {{ item.countpublic }}</p>
            </div>
          </div>
        </div>
        <div class="tspage" v-if="paginations.total > paginations.page_size">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="paginations.page_index"
            :page-size="paginations.page_size"
            :total="paginations.total"
            layout="prev, pager, next"
          ></el-pagination>
        </div>
      </div>
      <div class="res" v-else>
        <h3>
          未查询到关于<span>“{{ $route.query.keyword }}”</span>的信息
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue"
import { getKeywordNews } from "@/api/news.js"
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      newsData: [],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 330, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.getData()
    Bus.$on("getSearch", (e) => {
      this.getData()
    })
  },
  methods: {
    async getData() {
      let news = new FormData()
      news.append("page", this.paginations.page_index)
      news.append("rows", this.paginations.page_size)
      news.append("school", this.$route.query.keyword)
      let note = await getKeywordNews(news)
      this.paginations.total = note.total
      this.newsData = note.rows
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val
      this.getData()
    },
  },
  components: {
    AllHeader,
  },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 400px;
  }
  .content {
    padding-top: 20px;
    width: 810px;
    min-height: 300px;
    margin: 0px auto;
    .tswrapper {
      width: 90%;
      margin: 0px auto;
      .tscontent {
        width: 100%;
        .tsbox {
          width: 100%;
          border-bottom: dotted 1px #ededed;
          h3 {
            margin-top: 30px;
            font-size: 16px;
            width: 640px;
            color: #000;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            &:hover {
              text-decoration: underline;
            }
          }
          .tstime {
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            p {
              font-size: 14px;
              color: #3b3b3b;
            }
          }
        }
      }
      .tspage {
        margin: 70px 0 90px;
        text-align: center;
        /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #fd7a3a;
          border: none;
        }
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
          background-color: #fff; // 进行修改未选中背景和字体
          border: 1px solid #ededed;
          // color: #fff;
        }
        /deep/ .el-pagination.is-background button {
          background-color: #fff; // 进行修改未选中背景和字体
          border: 1px solid #ededed;
          // color: #fff;
        }
      }
    }
    .res {
      margin: 60px auto;
      text-align: center;
      font-size: 16px;
      span {
        color: red;
      }
    }
  }
}
</style>
